import myRequest from '@/utils/MyRequest';

export class api {
    
    getlogin ( data ) {
        return myRequest.post("api/login", data);
    }

    getloginOut () {
        return myRequest.get("api/logout" );
    }

    getUserDetial ( ) {
        return myRequest.get("api/getLoginUser" );
    }

    postUserList ( data ) {
        return myRequest.post("api/sysUser/page", data);
    }

    postAddUser ( data ) {
        return myRequest.post("api/sysUser/add", data);
    }

    postDeleteUser ( data ) {
        return myRequest.post("api/sysUser/delete", data);
    }

    postEditUserInfo ( data ) {
        return myRequest.post("api/sysUser/edit", data);
    }

    postProductList ( data ) {
        return myRequest.post("api/product/page", data);
    }

    postProductListD ( data ) {
        return myRequest.post("api/product/list", data);
    }

    postAddProduct ( data ) {
        return myRequest.post("api/product/add", data);
    }

    postEditProduct ( data ) {
        return myRequest.post("api/product/edit", data);
    }

    postDeleteProduct ( data ) {
        return myRequest.post("api/product/delete", data);
    }

    postUploadImage ( data ) {
        return myRequest.post("api/sysFileInfo/upload", data);
    }

    getSysFileInfoPreview ( data ) {
        return myRequest.get( "api/sysFileInfo/preview", data );
    }

    postNewsList ( data ) {
        return myRequest.post( "api/sysNews/page", data );
    }

    postNewsListD ( data ) {
        return myRequest.post( "api/sysNews/list", data );
    }

    postAddNews ( data ) {
        return myRequest.post("api/sysNews/add", data);
    }

    postModifyNews ( data ) {
        return myRequest.post("api/sysNews/edit", data);
    }

    postDeleteNews ( data ) {
        return myRequest.post("api/sysNews/delete", data);
    }
    
}

export default new api()
